var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"s-loader",class:{ '-small': _vm.small },style:({ ..._setup.spinnerStyle, '--spinner-color': _setup.colorValue })})
}
var staticRenderFns = []

export { render, staticRenderFns }